import React from 'react';
import './styles/Navigation.css';

export default function Navigation({ onHome }) {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <span className="logo-text">Graphics Simulator</span>
        </div>
        {onHome && (
          <button className="home-btn" onClick={onHome}>
            Home
          </button>
        )}
      </div>
    </nav>
  );
}
